'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _reactResponsiveCarousel = require('react-responsive-carousel');

var _components = require('../../components');

var _HomeTestimonials = require('./HomeTestimonials.css');

var _HomeTestimonials2 = _interopRequireDefault(_HomeTestimonials);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomeTestimonials = (_dec = (0, _reactCssModules2.default)(_HomeTestimonials2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(HomeTestimonials, _Component);

  function HomeTestimonials() {
    (0, _classCallCheck3.default)(this, HomeTestimonials);
    return (0, _possibleConstructorReturn3.default)(this, (HomeTestimonials.__proto__ || (0, _getPrototypeOf2.default)(HomeTestimonials)).apply(this, arguments));
  }

  (0, _createClass3.default)(HomeTestimonials, [{
    key: 'render',
    value: function render() {
      var carouselItems = [['fossil', _config2.default.routes.issueFossilFuels, 'Fossil fuels', 'Coal, oil, and gas release carbon pollution that accelerates the climate emergency. Rising temperatures will contribute to fires, floods, deadly heatwaves, and other environmental disasters.'], ['prisons', _config2.default.routes.issuePrisonIndustrialComplex, 'Prison industrial complex', 'Investor-owned companies are profiting from exploitative prison labor, immigration jails, and other economic systems of oppression and exploitation.'], ['deforestation', _config2.default.routes.issueDeforestation, 'Deforestation', 'Clearing rain forests for cattle grazing or palm oil production contributes to the climate crisis and threatens the rights of Indigenous peoples, traditional landowners, and local communities.'], ['military', _config2.default.routes.issueArmsManufacturers, 'Arms manufacturers', 'Through the global weapons trade, some arms manufacturers supply military goods to states at risk of using weapons for oppression or aggression.'], ['gender', _config2.default.routes.issueGenderEquality, 'Gender equality', 'Collecting data and scoring companies on gender equality is the first step towards sustainable change.'], ['guns', _config2.default.routes.issueCivilianFirearms, 'Civilian firearms', 'Over 90% of the country supports expanding background checks to all gun sales and the majority supports increased safety regulation, but many of these same people are invested their savings in firearm manufacturers and don’t even know it.'], ['tobacco', _config2.default.routes.issueTobacco, 'Tobacco', 'The World Health Organization describes tobacco as the most devastating, but preventable, epidemic of our time. Every day, more than 2,000 young Americans become daily smokers.']];
      //
      return _react2.default.createElement(
        _reactResponsiveCarousel.Carousel,
        {
          showStatus: false,
          showArrows: false,
          infiniteLoop: true,
          autoPlay: true,
          stopOnHover: true,
          swipeable: true,
          showThumbs: false,
          dynamicHeight: false,
          emulateTouch: true,
          interval: 7000
        },
        carouselItems.map(function (e, i) {
          var _e = (0, _slicedToArray3.default)(e, 4),
              style = _e[0],
              url = _e[1],
              title = _e[2],
              description = _e[3];

          return _react2.default.createElement(
            'div',
            {
              styleName: 'ht-img-bckgrnd-' + style,
              key: 'carousel-item-' + i
            },
            _react2.default.createElement(
              _components.ContainerDivs,
              null,
              _react2.default.createElement(
                'h2',
                { styleName: 'ht-hl' },
                title
              ),
              _react2.default.createElement(
                'h3',
                { styleName: 'ht-ds' },
                description
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'ht-tl' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: url,
                    title: 'The issue: ' + title
                  },
                  'Learn more'
                )
              )
            )
          );
        })
      );
    }
  }]);
  return HomeTestimonials;
}(_react.Component)) || _class);
exports.default = HomeTestimonials;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeTestimonials/HomeTestimonials.js
// module id = 1389
// module chunks = 0